export default defineNuxtRouteMiddleware(async () => {
  const { ensureLoaded } = useAuth()
  await ensureLoaded()
  // Display role (see role-admin-read) — a "View as" preview hides write-admin routes too.
  const { hasDisplayRole } = useViewAs()
  if (!(hasDisplayRole('Admin') || hasDisplayRole('Admin.Write'))) return navigateTo('/forbidden')
})
